<template>
  <div class="photography">
    <banner part-id="photography" />
    <AntiShake />
    <WideAngle />
  </div>
</template>

<script>
import Banner from '../Banner/PartBanner';
import AntiShake from './antiShake';
import WideAngle from './wideAngle';
export default {
  components: {
    Banner,
    AntiShake,
    WideAngle
  }
};
</script>

<style lang="scss" scoped>
.photography {
  width: 100%;
  overflow: hidden;
}
.photography__banner {
  width: 100vw;
  height: 100vh;
  background-color: #e5e5e5;
}
</style>
